var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileTick = function SvgProfileTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0312 15.8741L13.2979 17.1408L15.8313 14.6074",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1302 9.05768C10.0469 9.04935 9.94691 9.04935 9.85524 9.05768C7.87191 8.99102 6.29691 7.36602 6.29691 5.36602C6.28857 3.32435 7.94691 1.66602 9.98857 1.66602C12.0302 1.66602 13.6886 3.32435 13.6886 5.36602C13.6886 7.36602 12.1052 8.99102 10.1302 9.05768Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99219 18.1741C8.47552 18.1741 6.96719 17.7908 5.81719 17.0241C3.80052 15.6741 3.80052 13.4741 5.81719 12.1324C8.10885 10.5991 11.8672 10.5991 14.1589 12.1324",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgProfileTick;